import React, { useState, useRef, useMemo } from "react";
import { Container, Row, Col, Modal, Card, CardBody, Label, Input, FormFeedback } from "reactstrap";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';
import 'jodit/es5/jodit.min.css'; 
import JoditEditor from 'jodit-react'; 

const Emailformat = props => {
  //meta title
  document.title = "Email Formats";
  const { getRequest, postRequest } = useRequests();

  const editorConfig = useMemo(() => ({
    readonly: false,
    toolbar: true,
    autofocus: true,
    showSource: true,
    uploader: {
      insertImageAsBase64URI: true,
    },
    width: '1400px',
    height: '601px',
    buttons: [
      'bold', 'italic', 'underline', 'strikethrough',  '|',
      'font', 'fontsize', 'paragraph', 'align', 'list', '|',
      'link', 'image', 'table', 'undo', 'redo', 'cut', 'copy', 'paste',  '|',
      'source', 'preview',
    ],
    allowedTags: ['*'],
    allowAttributes: {
      '*': ['*'], 
    },
    cleanHTML: false,
  }), []);

  const [AlertData, setAlertData] = React.useState({
		variant: '',
		message: '',
	});
	const resetAlertData = () => {
		setTimeout(() => {
			setAlertData((AlertData) => ({
				...AlertData,
				variant: '',
				message: '',
			}));
		}, 5000);
	};


  const [StandardModal1, setStandardModal1] = React.useState(false);
  const togStandardModal1 = async (elementData) => {
    editorContentRef.current=elementData.email_body_format;
    validation1.setValues({
      ...validation1.values,
      ef_id: elementData.ef_id,
      title: elementData.title,
      variables: elementData.variables,
      subject: elementData.subject,
      email_body_format: elementData.email_body_format
    });
    setStandardModal1(true);
  }

  const validation1 = useFormik({
    enableReinitialize: true,
    
    initialValues: {
      ef_id: '',
      title: '',
      variables: '',
      subject: '',
      email_body_format: '',
    },
    validationSchema: Yup.object({
      subject: Yup.string().required('Subject is required'),
      email_body_format: Yup.string().required('Email Format is required'),
    }),
    onSubmit: async (values) => {
      try {
        if (values.email_body_format === "" || values.email_body_format == null) {
          validation1.setFieldError("email_body_format", "Email Format is required");
          return;
        }

        let submit1 = document.getElementById('submit1');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        const jsonpar = JSON.stringify({
          ef_id: values.ef_id,
          subject: values.subject,
          email_body_format: values.email_body_format
        });
        const res = await postRequest('update-email-format-data', jsonpar);
        if (res && res.code === 200) {
          handleLoadGetEmailFormatData();

          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'success',
            message: res.message,
          }));
        }
        else {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: res.message,
          }));
        }
        resetAlertData();

        submit1.disabled = false;
        submit1.textContent = 'Update';

        setStandardModal1(false);
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });
  
  const [EmailFormatDataTBody, setEmailFormatDataTBody] = React.useState('');
  const handleLoadGetEmailFormatData = async () => {
    const res = await getRequest('get-email-format-data');
    if (res && res.code === 200) {
      let originalText = res.data;

      let tempTBody = originalText.map((element, index) => (
        <tr key={index}>
          <td>{index + 1}</td>
          <td>{element.title}</td>
          <td>{element.subject}</td>
          <td>{element.lang}</td>
          <td className="text-center">
            <div className="centerLink">
              <span title="Edit Email Format Settings" className="font-size-14 bg-primary edit-box" onClick={(e)=>togStandardModal1(element)}><i className="bx bxs-edit"></i></span>
            </div>
          </td>
        </tr>
      ));

      setEmailFormatDataTBody(tempTBody);
    }
    else {
      let tempTBody = (<tr>
                        <td colSpan="5" className="text-center">No records found</td>
                      </tr>);

      setEmailFormatDataTBody(tempTBody);

      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  }

  const editorContentRef = useRef(validation1.values.email_body_format); 
  const handleEditorChange = (newContent) => {
    if (newContent !== editorContentRef.current) {
      editorContentRef.current = newContent;
    }
  };
  const handleSubmit = () => {
    validation1.setValues({
      ...validation1.values,
      email_body_format: editorContentRef.current
    });
  };

  React.useEffect(() => {
    handleLoadGetEmailFormatData();
  }, []);


  return (
    <React.Fragment>
			{AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={props.t("Tokenizedgreen")} breadcrumbItem={props.t("Email Formats")} />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="table-rep-plugin">
                    <div className="table-responsive mb-0">
                      <table className="table table-hover table-highlight" style={{minWidth: '600px'}}>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Title</th>
                            <th>Subject</th>
                            <th>Language</th>
                            <th className="text-center">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {EmailFormatDataTBody}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

        </Container>
      </div>

      <Modal size="xl" centered backdrop="static" isOpen={StandardModal1}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Email Formats</h5>
          <button type="button" onClick={(e)=>setStandardModal1(false)} className="close" data-dismiss="modal" aria-label="Close" >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <Col md={12}>
            <div className="mb-3">
              <Label className="form-label">Title</Label>
              <Input name="title" type="text" placeholder="Enter title" disabled
                value={validation1.values.title || ""}
              />
            </div>
          </Col>
          <Col md={12}>
            <div className="mb-3">
              <Label className="form-label">Subject</Label>
              <Input name="subject" type="text" placeholder="Enter subject"
                onChange={validation1.handleChange}
                onBlur={validation1.handleBlur}
                value={validation1.values.subject || ""}
                invalid={
                  validation1.touched.subject && validation1.errors.subject ? true : false
                }
              />
              {validation1.touched.subject && validation1.errors.subject ? (
                <FormFeedback type="invalid">{validation1.errors.subject}</FormFeedback>
              ) : null}
            </div>
          </Col>
          <Col md={12}>
            <div className="mb-3">
              <Label className="form-label">Variables</Label>
              <div dangerouslySetInnerHTML={{ __html: validation1.values.variables }} />
            </div>
          </Col>
          <Col md={12}>
            <div className="mb-3">
              <Label className="form-label">Email Format</Label>
              <JoditEditor
                value={validation1.values.email_body_format}
                onChange={handleEditorChange}
                config={editorConfig}
              />
              {validation1.touched.email_body_format && validation1.errors.email_body_format ? (
                <FormFeedback type="invalid">{validation1.errors.email_body_format}</FormFeedback>
              ) : null} 
            </div>
          </Col>
        </div>
        <div className="modal-footer">
          <button type="button" 
            id="submit1"
            onClick={(e) => {
              e.preventDefault();
              handleSubmit();
              validation1.handleSubmit();
              return false;
            }}
          className="btn btn-primary" data-dismiss="modal" aria-label="Close">Update</button>
          <button type="button" onClick={(e)=>setStandardModal1(false)} className="btn btn-light" data-dismiss="modal" aria-label="Close">Close</button>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default withTranslation()(Emailformat);
